
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".01","d":"M0 0h20v20H0z"}}),_c('path',{attrs:{"d":"M10 1.667a8.333 8.333 0 110 16.666 8.333 8.333 0 010-16.666zm-5.511 4.29L4.459 6a6.833 6.833 0 009.74 9.39l-2.212-2.133h-4.91l.001.397a.69.69 0 01-.376.609l-.089.039-.095.028-.081.013-.079.004a.716.716 0 01-.7-.53l-.016-.087-.004-.076-.001-.396H4.583l-.083-.083v-3.043c0-.662.385-1.26.989-1.568l.148-.067v-.254c0-.325.07-.635.197-.918L4.65 6.183a.836.836 0 01-.161-.225zM10 3.168c-1.7 0-3.254.62-4.45 1.647.104.041.2.103.283.186L7.02 6.143c.156-.071.322-.128.495-.166l.143-.028.146-.019.13-.01.131-.003h3.872c1.24 0 2.271.894 2.41 2.06l.013.14.003.126v.253l.019.008c.502.209.878.615 1.037 1.106l.037.136.027.14.014.123.004.123v3.043l-.083.083-1.02-.001.987.951A6.833 6.833 0 0010 3.167zM6.356 9.736l-.075.007a.412.412 0 00-.319.261l-.017.069-.004.059-.001 1.74h.835v-1.74a.4.4 0 00-.282-.375l-.072-.017-.065-.004zm7.283 0l-.074.007a.412.412 0 00-.319.261l-.017.069-.004.059v1.74h.833l.001-1.74a.4.4 0 00-.282-.375l-.072-.017-.066-.004zm-5.442.142l.015.131.004.123v1.735h2.329l-2.45-2.364c.048.12.082.245.102.375zm3.735-2.575h-3.71l3.562 3.434v-.605c0-.662.385-1.26.989-1.568l.148-.067v-.254c0-.454-.339-.838-.793-.923l-.099-.013-.097-.004z"}})])
          )
        }
      }
    